import React from "react";
import { useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import BankAccItemBody from "./BankAccItemBody";
import { getSelectedBankTrans } from "../../util/APIUtils";
import BankTransferModal from "./BankTransferModal";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function BankAccListBody({
  data,
  transferPayment,
  onChangeTransfer,
  cancel,
  updateTransfer,
  toggle,
  modal,
  fromBank,
}) {
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [flag, setFlag] = useState(true);
  const [items, setItems] = useState([]);

  const handleMenuItemClick = (action, row) => {
    setContextMenuOpen(false);
    if (action === 1) {
      loadItems(row);
    }
    if (action === 2) {
      fromBank(row.bankName);
      toggle();
    }
  };

  const back = () => {
    setFlag(!flag);
  };

  const loadItems = (row) => {
    let obj = { bankName: row.bankName };
    getSelectedBankTrans(obj).then((response) => {
      setItems(response);
      setFlag(!flag);
    });
  };

  const handleRightClick = (e, row) => {
    //  e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setContextMenuOpen(true);
    setCurrentRow(row);
  };

  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <Button
          className="btn btn-warning"
          id={"more" + rowIndex}
          onClick={(e) => handleRightClick(e, row)}
          style={{ marginLeft: "5px" }}
        >
          <i className="fa fa-ellipsis-v" />
        </Button>
      </span>
    );
  };
  return (
    <div>
      <BankTransferModal
        OnToggle={toggle}
        view={modal}
        updateTransfer={updateTransfer}
        options={data}
        onChangeTransfer={onChangeTransfer}
        cancel={cancel}
        transferPayment={transferPayment}
      />
      {flag ? (
        <Card>
          <CardHeader className="carheaderSmall">
            <strong>Bank Accounts</strong>
          </CardHeader>
          <CardBody>
            <BootstrapTable
              data={data}
              version="4"
              condensed={true}
              striped
              hover
              pagination
              search
              options={options}
              exportCSV
              csvFileName="Bank_accounts.csv"
            >
              <TableHeaderColumn
                isKey
                dataField="id"
                export={false}
                hidden={true}
              >
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="bankName"
                csvHeader="Bank name"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Bank name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="currentBankBalance"
                csvHeader="balance"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Balance
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={cellButton}
                hiddenOnInsert
                export={false}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          </CardBody>
        </Card>
      ) : (
        <BankAccItemBody data={items} onBack={back} />
      )}

      {contextMenuOpen && (
        <Dropdown
          isOpen={contextMenuOpen}
          toggle={() => setContextMenuOpen(false)}
          style={{
            position: "fixed",
            top: contextMenuPosition.y,
            left: contextMenuPosition.x,
          }}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            aria-expanded={true}
          />
          <DropdownMenu>
            <DropdownItem onClick={() => handleMenuItemClick(1, currentRow)}>
              View Details
            </DropdownItem>
            <DropdownItem onClick={() => handleMenuItemClick(2, currentRow)}>
              Transfer
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/BankAccListBody.js